/**
 * Exemple d’interface pour la réponse côté serveur
 * (à adapter selon la structure réelle de vos données).
 */
interface SessionData {
    notes?: string;
    sujet?: string;
    visualFieldSelection?: {
      timeline?: string;
    };
    parameters: {
      content: string; // on va parser ce JSON
    }[];
  }
  
  interface AdaptedParameters {
    [key: string]: {
      sous_module: string;
      selected: boolean;
      forme?: string;
      taille: string;
      nombre_par_hemichamp?: string;
      couleur_cible?: string;
      couleur_fond?: string;
      side?: string;
      mouvement?: string;
      type_forme?: string;
      side_aveugle?: string;
      parametre?: string;
      contenu?: number | string;
      instructions?: string;
      vitesse?: string;
      duree: string;
      zt?: string;
    };
  }
  
  interface AdaptedData {
    parameters: AdaptedParameters;
    notes: string;
    sujet: string;
    visualFieldSelection: string;
  }
  
  /**
   * Transforme les données brutes de l’API en données adaptables
   * au schéma React Hook Form.
   */
  export function makeAdaptedData(sessionData: SessionData): AdaptedData {
    // Sécurisation : s’il n’y a pas de sessionData.parameters, on le met par défaut à []
    const parametersArray = sessionData.parameters || [];
  
    // On réduit le tableau `parameters` pour construire un objet clef => valeur
    // basé sur le champ `sous_module`.
    const adaptedParameters: AdaptedParameters = parametersArray.reduce(
      (acc: AdaptedParameters, param) => {
        // Exemple : param.content est une string JSON du type
        // {"sous_module":"ZPL","selected":true,"couleur_fond":"black", ...}
        const content = JSON.parse(param.content);
        const key = content.sous_module;
  
        // On fusionne avec ce qu’il y a déjà dans acc[key] (s’il y avait déjà des infos).
        acc[key] = { ...acc[key], ...content };
        return acc;
      },
      {}
    );
  
    // On construit l’objet final qui sera passé dans `form.reset()`
    return {
      parameters: adaptedParameters,
      notes: sessionData.notes || "",
      sujet: sessionData.sujet || "",
      visualFieldSelection: sessionData.visualFieldSelection?.timeline || ""
    };
  }
  